
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import { namespace, Getter } from "vuex-class";
import { DispatchGuard, Guard } from "@/store/dispatch/types";
import { FeaturesList } from "@/store/types";
import { get } from "lodash";

const DispatchStore = namespace("dispatch");
const MobileModule = namespace("mobile");

@Component
export default class ManualGuardRow extends Vue {
    @Getter isFullUser: boolean;
	@Prop()	public guardElement: Guard;

    @Prop(Number) public eventId: Number;

    @Getter("getFeaturesList") featuresList: FeaturesList;
	@Getter("getFeature") getFeature: (featureName: string[]) => boolean;

    @DispatchStore.Getter("getDispatchedGuards")
    dispatchedGuards: DispatchGuard[];

	@DispatchStore.Getter getGuardStatus: (id: number) => number;
	@MobileModule.Getter getGuardStatusMobile: (id: number) => number;

   	@DispatchStore.Action dispatchGuard: (dispatchGuardRequest: any) => Promise<boolean>;
	@MobileModule.Mutation updateMobileGuardStatus: ({ guardId, status}: { guardId: number, status: number}) => void;
	@DispatchStore.State EventLocation: string;

	public disableArrivedButton: boolean = false;

    public async dispatch(guardID: number) {
		if (this.isGuardDispatchable(guardID)) {
			const result = await this.dispatchGuard({
				guardID: guardID,
				eventID: this.eventId,
				status: 2,
				location: this.EventLocation
			});

			if (result) {
				this.updateMobileGuardStatus({ guardId: guardID, status: 2 });
			}
		}
	}

	public async arrived(guardID: number) {
		this.disableArrivedButton = true;
		const result = await this.dispatchGuard({
			guardID: guardID,
			eventID: this.eventId,
			status: 3
		});


		if (result) {
			this.updateMobileGuardStatus({ guardId: guardID, status: 3 });
		}
		this.disableArrivedButton = false;
	}

	public async clearDispatch(guardID: number) {
		const result = await this.dispatchGuard({
			guardID: guardID,
			eventID: this.eventId,
			status: 1
		});

		if (result) {
			this.updateMobileGuardStatus({ guardId: guardID, status: 1 });
		}
	}

	public statusText(guardID: number): string {
		let status = 0;

		if (this.getFeature(["Mobile", "Dispatch"])) {
			status = this.getGuardStatusMobile(guardID);
		} else {
			status = this.getGuardStatus(guardID);
		}

		switch (status) {
			case 1:
				return "Available";
			case 2:
				return "En Route";
			case 3:
				return "Arrived";
			case 4:
				return "On break";
			default:
				return "";
		}
    }

    public isGuardDispatchable(guardId: number) {
		const isGuardAlreadyDispatched = this.dispatchedGuards.filter(g => g.guardID == guardId).length == 1;
		if (isGuardAlreadyDispatched) {
			return false;
		}

		const isAnyGuardAttendingEvent = this.dispatchedGuards.length > 0;
		if (!isAnyGuardAttendingEvent) {
			return true;
		}
		const isMultiDipatchEnabled = get(this.featuresList, ["Alarms", "Dispatch", "MultiDispatch"]);
		if (isAnyGuardAttendingEvent && isMultiDipatchEnabled) {
			return true;
		}

		return false;
	}

	public getFormattedCallsign(callsign: string) {
		return callsign.substring(0, 12) + "...";
	}
}

